module.exports = __webpack_public_path__ + "media/images/athletes/59-6518c82f1baafb86cb61dee5bc2413d9.png";